module.exports = __webpack_public_path__ + "img/img11.65c50b92.png";